import { render, staticRenderFns } from "./roleIndex.vue?vue&type=template&id=243db707&scoped=true"
import script from "./roleIndex.vue?vue&type=script&lang=js"
export * from "./roleIndex.vue?vue&type=script&lang=js"
import style0 from "./roleIndex.vue?vue&type=style&index=0&id=243db707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243db707",
  null
  
)

export default component.exports